module.exports = __webpack_public_path__ + "static/media/solitary_02.d0cabec3.jpg";